<template>
  <main class="home-page" aria-label="Main content">
    <div class="school-logo">
      <div v-if="settings.show_background_color_logo" :style="translucentBoxStyle" class="translucent-box"></div>
      <img :src="settings.main_logo" alt="" role="presentation">
    </div>
    <div class="heading-wrapper" role="presentation">
      <h1 class="secondary-text">{{ $tr(settings.title_home_page) }}</h1>
    </div>
    <div class="home-menu secondary-text" role="presentation">
      <ul role="menu" aria-label="Menu">
        <li class="home-btn" role="menuitem">
          <router-link :to="{name: 'ExploreCampus'}" tag="a" >
            <i aria-hidden="true" class="material-icons">place</i>
            <span>{{ $t("button.exploreCampus") }}</span>
          </router-link>
        </li>
        <li class="home-btn" role="menuitem">
          <router-link :to="{name: 'CuratedTour'}" tag="a">
            <i aria-hidden="true" class="material-icons">directions_run</i>
            <span>{{ $t("button.curatedTour") }}</span>
          </router-link>
        </li>
        <li class="home-btn" role="menuitem">
          <router-link :to="{name: 'PersonalizedCategories'}" tag="a">
            <i aria-hidden="true" class="material-icons">map</i>
            <span>{{ $t("button.personalizedTour") }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Home',
  computed: {
    ...mapState({
      settings: state => state.college.settings
    }),
    translucentBoxStyle () {
      return {
        backgroundColor: this.settings.background_color_logo,
        opacity: this.settings.background_color_logo_opacity
      }
    }
  }
}
</script>
